import React from 'react'

import CardColumn from '@SonarCX/components/atoms/CardColumn'
import Card, { CardProps } from '../Card'

import useStyles from './styles'

type CardsProps = {
  fields: LocalCustomField[]
  rowsToRender: APIMeta[][]
} & Omit<CardProps, 'cells' | 'fields'>

const Cards: React.FC<CardsProps> = ({
  fields,
  rowsToRender,
  table,
  meta,
  canEdit,
  ...props
}) => {
  const classes = useStyles()

  return (
    <CardColumn className={classes.root}>
      {rowsToRender.map((cells: APIMeta[], rowIndex: number) => (
        <Card
          key={`${table.id}-${rowIndex}`}
          table={table}
          cells={cells}
          meta={meta}
          fields={fields}
          canEdit={canEdit}
          {...props}
        />
      ))}
    </CardColumn>
  )
}

export default Cards
